import React, { Component } from 'react';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { CustomStats } from '../../components/custom_stat';
import { COLORS } from '../theme';
import { Table, Button, Divider, message, Spin, Popconfirm, Space, Tooltip } from 'antd';
import { GetAppOutlined, Refresh, AssignmentReturn, KitchenOutlined } from '@material-ui/icons';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { showErrorInNotification, formatMoney, copyStringToClipboard, showSuccessInNotification } from '../../lib/util';
import { PopUpForm } from '../../lib/ui/popupform';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { TextTag } from '../../components/basic_items';
import DayDifferennceTag from '../../components/day_difference_tag';

const queryString = require('query-string');


class FetcherResponseDetail extends Component {
  constructor(props) {
    super(props)
    this.log_id = props.match.params.log_id;
    this.response_id = props.match.params.response_id;

    this.state = {
      response_info: {},
      loading: true,
      filter_query: {},
      reprocessed_file_ids: [],
      reprocessing_id: null
    }


    this.detail_response = RESTExecutor.detail().config({
      label: 'fetcher_logs_detail'
    }).callbacks((success) => {
      this.setState({ loading: false, response_info: success.result });
      this.list_data_responses.forId(this.response_id).config({
        params: {
          ...this.state.filter_query
        }
      }).execute();
    }, (error) => {
      this.setState({ loading: false })
      showErrorInNotification(error)
    }).forId(this.log_id).connect(props.domains.fetcher);


    this.delete_fetcher_response = RESTExecutor.delete().config({
      label: 'fetcher_responses_detail',
      params: {}
    }).callbacks((success) => {
      showSuccessInNotification(success, "Response deleted");
      this.props.history.goBack();
    }, (error) => {
      showErrorInNotification(error);
      // this.props.history.goBack();
    }).connect(props.domains.fetcher);



    this.list_data_responses = RESTExecutor.detail().config({
      label: 'fetcher_responses_datatypes',
      params: {
        ...this.state.filter_query
      }
    }).callbacks((success) => { }).forId(this.log_id).connect(props.domains.fetcher);

    this.download_response = RESTExecutor.detail().config({
      label: 'download_responses'
    }).callbacks((success) => {
      window.open(success.result.url, '_blank');
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.download_transaction = RESTExecutor.detail().config({
      label: 'transaction_download'
    }).callbacks((success) => {
      window.open(success.result.url, '_blank');
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.re_run = RESTExecutor.post().config({
      label: 'rerun_responses'
    }).callbacks((success) => {
      message.success(success.result.message || "Running selector.");
      this.setState({
        selected_data: {},
        re_run_modal: false,
        form_data: {}
      })
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.untransfer_fetcher_response=RESTExecutor.post().config({
      label:'untransfer_response',
      params:{}
    }).callbacks((success)=>{
        showSuccessInNotification(success,"Response Untransferred");
    },(error)=>{
      showErrorInNotification(error);
    }).connect(props.domains.fetcher);

    this.reprocess_file = RESTExecutor.post().config({
      label: 'file_reprocess',
      params: {}
    }).callbacks((success) => {
      try {
        this.loading_message();
      } catch (e) {

      }
      let reprocessing_id = this.state.reprocessing_id;
      let new_reprocessed_file_ids = this.state.reprocessed_file_ids;
      new_reprocessed_file_ids.push(reprocessing_id);
      this.setState({
        reprocessed_file_ids: new_reprocessed_file_ids,
        reprocessing_id: null
      })

      message.success(success.result.message || "Reprocessing File");
    }, (error) => {
      try {
        this.loading_message();
      } catch (e) {


      }
      this.setState({
        reprocessing_id: null
      })
      showErrorInNotification(error);
    }).connect(props.domains.activity);


  }

  reRun = (data) => {

    this.re_run.forId(this.response_id).execute(data);
    // Rerun for given responses
  }

  render() {
    const { loading, filter_query, response_info, reprocessed_file_ids, reprocessing_id } = this.state;

    if (loading) {
      return <center><Spin /></center>
    }

    let reprocessed_list = [...reprocessed_file_ids, reprocessing_id];

    let detail_response_resp = this.detail_response.response();
    let list_data_responses_resp = this.list_data_responses.response();
    let list_data_responses_data = list_data_responses_resp.result || {};
    let rowsData = list_data_responses_data.rows || [];
    let rowsMeta = list_data_responses_resp.meta || {}

    let re_run_resp = this.re_run.response();

    const required_fields = [
      { filterable: true, index: 'selectors', name: "Selector", help_text: "Which selector to run for given file.", type: 'networkselect', url: `/fetcher-responses/${this.response_id}/selectors`, mode: 'tags' }
    ]


    return (
      <ErrorWrapper
        error={detail_response_resp}
        onReload={() => {
          this.log_id = this.props.match.params.log_id;
          this.detail_response.forId(this.log_id).execute()
        }}
      >
        <div>
          <BasicHeader
            title="Fetcher Response Detail"
            subtitle={response_info.repository_name}
          />

          <PopUpForm
            width="60%"
            key={`rerun`}
            title={"Selector to Rerun"}
            show_title_only
            forCreate={true}
            initialData={this.state.form_data}
            fields={required_fields}
            open={this.state.re_run_modal}
            networkState={re_run_resp}
            onClose={() => {
              console.log("closing upload form")
              this.setState({
                re_run_modal: false,
                selected_data: {},
                form_data: {}
              })
            }
            }
            onSubmit={(data) => {
              console.log("DATA", data);
              this.reRun(data);
            }}
          />

          <div className='default-card' style={{
            // margin: 0,
            marginTop: 30
          }}>


            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingTop: 16,
              paddingLeft: 20, paddingRight: 20,
              paddingBottom: 16,
              alignItems: 'center'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}> <Space size={20}>
                  <div className='credit-circle'>{response_info.manual == true ? "M" : "A"}</div>
                  <div className='description-text' style={{
                    fontWeight: 'bold'
                  }}>{response_info.executed_at}</div>
                  <DayDifferennceTag date={response_info.executed_at} />

                </Space>

              </div>
              <Space size={40}>
                {/* <TextTag type={response_info.status == "Completed" ? "success" :
                  response_info.status == "Error" ? 'danger' : 'warning'
                } label={(response_info.status || "").toUpperCase()} /> */}
                <div style={{
                  // width: 100,
                  display: 'flex', flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>

                  <Popconfirm
                    title="Are you sure to delete this response?"
                    onConfirm={() => {
                      this.delete_fetcher_response.config({
                        params:{
                          repository_id:response_info.repository_id,
                          response_id:this.response_id
                        }
                      }).execute();

                    }}
                    okText="Yes"
                    cancelText="No"
                  >

                    <Button title="Delete"

                      onClick={() => {
                        // typeof props.onRerun === 'function' && props.onRerun(data)
                      }}
                      size='small'
                      style={{
                        padding: 0,
                        color: COLORS.danger_primary

                      }} type='link'>Delete</Button>
                  </Popconfirm>
                  <Divider type='vertical' />
            <Popconfirm
              title="Are you sure to untransfer this response?"
              onConfirm={() => {
                this.untransfer_fetcher_response.forId(this.response_id).execute();
              }}
              okText="Yes"
              cancelText="No"
            >
            <Button title="Untransfer"
              size='small'
              style={{
                padding: 0
              }} type='link'>Untransfer</Button>
              </Popconfirm>
                  <Divider type='vertical' />

                  <Button title="Rerun"
                    onClick={() => {
                      this.setState({
                        re_run_modal: true
                      })
                    }}
                    style={{
                      padding: 0
                    }} type='link'>Re-run</Button>
                  <Divider type='vertical' />
                  <GetAppOutlined
                    style={{
                      marginLeft: 8
                    }}
                    onClick={() => {
                      this.download_response.forId(this.response_id).execute()
                    }}
                    titleAccess="Download File" className='basic-icon hand-cursor' />
                  <Divider type='vertical' />
                  <Link to={{
                    pathname: `/activity/fetcher/logs/${this.log_id}`,
                    // search: queryString.stringify({
                    //   file_uri: record.file_uri,
                    //   fetcher_response_id: record.fetcher_response_id,
                    //   data_selector_id: record.data_selector_id
                    // })
                  }}>
                    <KitchenOutlined
                      titleAccess='Go To Log'
                      className='basic-icon hand-cursor'
                    // onClick={() => {
                    //     console.log("detail clicked")
                    //     typeof onViewclicked === 'function' && onViewclicked(id)
                    // }} 
                    /></Link>
                </div>
              </Space>


            </div>
          </div>
          <ErrorWrapper
            error={list_data_responses_resp}
            onReload={() => {
              this.list_data_responses.execute()
            }}
          >
            <div className='default-card' style={{
              // marginLeft: 0, marginRight: 0,
              marginTop: 20
            }}>
              <Table
                dataSource={rowsData}
                loading={list_data_responses_resp.fetching}
                className='main-table padder'
                bordered={true}
                size='small'
                rowClassName={(record) => {
                  // console.log("record",record);
                  return record.data_type_processed == false ? 'no-selector-row' :
                    record.selector_success == false ? 'error-row-1' : ''
                }}
                pagination={{
                  simple: false,
                  size: 'small',
                  position: 'bottom',
                  onChange: (current, size) => {
                    this.props.history.push({
                      search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                    })
                  },
                  defaultCurrent: 1,
                  current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                  pageSize: (rowsMeta && rowsMeta.requested_count),
                  total: (rowsMeta && rowsMeta.total_count),
                  showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${formatMoney(total, 0)} items`
                }}
                columns={[
                  {
                    title: "File",
                    dataIndex: 'file_uri',
                    key: 'file_uri',
                    className: 'word-break',
                    // width: 200,
                    render: (file_name, record) => {
                      let has_run = record.file_processed === false || (record.file_processed == true && record.processing_error == true);
                      return <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}>
                        {record.error_message ?
                          <Tooltip title={<div className='log-text'>
                            {(record.error_message || "Error Message not available")}
                          </div>}
                            placement='bottomRight'
                            arrowPointAtCenter
                            autoAdjustOverflow
                            overlayClassName={record.error_message ? 'error-tooltip side-scroll' : ''}
                          >
                            <div
                              onClick={(e) => {
                                copyStringToClipboard(record.error_message);
                                message.success("Copied")
                              }}
                              className='hand-cursor dot-indicator danger' style={{
                                marginRight: 8
                              }}>
                            </div></Tooltip>
                          :
                          <div className={`dot-indicator ${record.error ? 'danger' : ''}`} style={{
                            marginRight: 8
                          }}></div>
                        }
                        {file_name ? <Link style={{
                          display: 'flex',
                          alignItems: 'center'
                        }} to={`/activity/data-type/${record.data_type_id}/files/${record.id}/view`}>

                          <span>
                            {file_name}</span>
                        </Link> :
                          !record.data_type_processed ? <span>Selector not applied yet</span> :
                            record.error == true && record.selector_success == false ? <span>Error while Applying Selector</span> :
                              <span>No File Extracted</span>}

                        {/* <span>{file_name || "No File Extracted"}</span> */}

                        {has_run && !reprocessed_list.includes(record.id) && <Popconfirm
                          onConfirm={() => {
                            this.loading_message = message.loading(`Reprocessing ${file_name}`, 0);
                            this.setState({
                              reprocessing_id: record.id
                            })
                            this.reprocess_file.config({
                              params: {
                                response_id: record.fetcher_response_id,
                                file_id: record.id
                              }
                            }).execute();
                            // typeof props.onReprocessFile === 'function' && props.onReprocessFile(record.id, record.fetcher_response_id, file_name)
                          }}
                          title="Are you sure you want to run this file?">
                          <Refresh className='hand-cursor'
                            titleAccess="Rerun"
                            style={{
                              height: 20,
                              color: COLORS.primary,
                              width: 20,
                              // border:'1px solid',
                              // borderRadius:'50%',
                              marginLeft: 8
                            }} /></Popconfirm>}

                      </div>
                    }

                  },
                  {
                    title: "DATATYPE",
                    dataIndex: 'data_type',
                    key: 'data_type',
                    className: 'word-break',
                    render: (value, record) => {
                      let has_run = false;
                      return <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                      }}>
                        <span>{value}</span>
                        {has_run && <Popconfirm title="Are you sure you want to run this file?">
                          <Refresh className='hand-cursor'
                            titleAccess="Rerun"
                            style={{
                              height: 20,
                              color: COLORS.primary,
                              width: 20,
                              // border:'1px solid',
                              // borderRadius:'50%',
                              marginLeft: 8
                            }} /></Popconfirm>
                        }
                      </div>
                    }
                  },

                  {
                    title: "Pipeline ",
                    className: 'pipeline-cols',
                    children: [
                      {
                        title: "Blocks",
                        width: 100,
                        key: 'blocks_count',
                        dataIndex: 'blocks_count',
                        className: 'pipeline-cols center-align',
                        render: (success_count = 0, record) => success_count == null ? <span className='right-align'>-</span> :
                          <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>{record.file_processed == true && record.processing_error == true && success_count > 0 ? <Link to={{
                            pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                            search: queryString.stringify({
                              // success_type:1
                            })
                          }}>
                            <span className='right-align'>{formatMoney(success_count, 0)}</span>
                          </Link> :
                            <span className='right-align'>{formatMoney(success_count, 0)}</span>
                            }</div>
                      },
                      {
                        title: "Parser",
                        width: 100,
                        key: 'Parser',
                        className: 'pipeline-cols center-align',
                        render: (record) => {
                          let success_count = record.parsing_success;
                          let error_count = record.parsing_error;
                          let obj = {
                            children: record.show_dash == true ? <span className='right-align'>-</span> : <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center'
                            }}>

                              {error_count > 0 ? <Link to={{
                                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                                search: queryString.stringify({
                                  status: 'error',
                                  error_type: 1
                                })
                              }}>
                                <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                              </Link> :
                                <span className='right-align'>{formatMoney(success_count, 0)}</span>
                              }
                            </div>,
                            props: {
                              className: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false) ? '' : error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                            }
                          }
                          return obj;
                        }
                      },
                      {
                        title: "Normalizer",
                        width: 100,
                        key: 'Normalizer',
                        className: 'pipeline-cols center-align',
                        render: (record) => {
                          let success_count = record.normalization_success;
                          let error_count = record.normalization_error;
                          let obj = {
                            children: record.show_dash == true ? <span className='right-align'>-</span> : <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center'
                            }}>

                              {error_count > 0 ? <Link to={{
                                pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                                search: queryString.stringify({
                                  status: 'error',
                                  error_type: 2
                                })
                              }}>
                                <span className='error-text'>{formatMoney(success_count, 0)} (-{formatMoney(error_count, 0)})</span>
                              </Link> :
                                <span className='right-align'>{formatMoney(success_count, 0)}</span>
                              }
                            </div>,
                            props: {
                              className: record.data_type_processed == false || record.selector_success == false || (record.file_processed == false) ? '' : error_count > 0 ? 'pipeline-error-cell' : 'pipeline-success-cell'
                            }
                          }
                          return obj;
                        }

                      },
                      // {
                      //   title: "Classifier",
                      //   width: 88,
                      //   key: 'Classifier',
                      //   render: (record) => {
                      //     let success_count = record.classification_success;
                      //     let error_count = record.classification_error;
                      //     return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
                      //       display: 'flex',
                      //       flexDirection: 'column',
                      //       alignItems: 'flex-end'
                      //     }}>
                      //       {record.file_processed == false && success_count > 0 ? <Link to={{

                      //         pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                      //         search: queryString.stringify({
                      //           success_type: 3
                      //         })
                      //       }}>
                      //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //       </Link> :
                      //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //       }
                      //       {error_count > 0 && record.file_processed == false &&
                      //         <Link to={{
                      //           pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                      //           search: queryString.stringify({
                      //             status: 'error',
                      //             error_type: 3
                      //           })
                      //         }}>
                      //           <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
                      //         </Link>}</div>
                      //   }
                      // },
                      // {
                      //   title: "Extractor",
                      //   width: 90,
                      //   key: 'Extractor',
                      //   render: (record) => {
                      //     let success_count = record.extraction_success;
                      //     let error_count = record.extraction_error;
                      //     return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
                      //       display: 'flex',
                      //       flexDirection: 'column',
                      //       alignItems: 'flex-end'
                      //     }}>
                      //       {record.file_processed == false && success_count > 0 ? <Link to={{

                      //         pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                      //         search: queryString.stringify({
                      //           success_type: 4
                      //         })
                      //       }}>
                      //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //       </Link> :
                      //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //       }
                      //       {error_count > 0 && record.file_processed == false &&
                      //         <Link to={{
                      //           pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                      //           search: queryString.stringify({
                      //             status: 'error',
                      //             error_type: 4
                      //           })
                      //         }}>
                      //           <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
                      //         </Link>}</div>
                      //   }
                      // }, {
                      //   title: "Enricher",
                      //   width: 82,
                      //   key: 'Enricher',
                      //   render: (record) => {
                      //     let success_count = record.enrichment_success;
                      //     let error_count = record.enrichment_error;
                      //     return record.data_type_processed == false ? <span className='right-align'>-</span> : <div style={{
                      //       display: 'flex',
                      //       flexDirection: 'column',
                      //       alignItems: 'flex-end'
                      //     }}>
                      //       {record.file_processed == false && success_count > 0 ? <Link to={{

                      //         pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                      //         search: queryString.stringify({
                      //           success_type: 5
                      //         })
                      //       }}>
                      //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //       </Link> :
                      //         <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //       }
                      //       {error_count > 0 && record.file_processed == false &&
                      //         <Link to={{
                      //           pathname: `/activity/data-type/${record.data_type_id}/files/${record.id}`,
                      //           search: queryString.stringify({
                      //             status: 'error',
                      //             error_type: 5
                      //           })
                      //         }}>
                      //           <span className='error-text'>{formatMoney(error_count, 0)} Errors</span>
                      //         </Link>}</div>
                      //   }
                      // },
                      // {
                      //   title: "Transactions",
                      //   width: 118,
                      //   key: 'Transactions',
                      //   dataIndex:'transferred_txns',
                      //   render: (success_count=0, record) => {
                      //     let error_count = record.txns_count-success_count;
                      //     return record.data_type_processed==false? <span className='right-align'>-</span>: <div style={{
                      //       display: 'flex',
                      //       flexDirection: 'column',
                      //       alignItems: 'flex-end'
                      //     }}>
                      //       {success_count>0?
                      //       <Link  to={{
                      //         pathname:`/activity/data-type/${record.data_type_id}/transactions`,
                      //       }}>
                      //       <span className='right-align'>{formatMoney(success_count, 0)}</span>
                      //      </Link>
                      //   :<span className='right-align'>{formatMoney(success_count,0)}</span> 
                      //   }
                      //       {error_count > 0 &&
                      //         <Link  to={{
                      //           pathname:record.file_processed==true?`/activity/data-type/${record.data_type_id}/nottransferredtransactions`:
                      //           `/activity/data-type/${record.data_type_id}/files/${record.id}`
                      //           ,
                      //           search: queryString.stringify({
                      //             // fetcher_response_id:record.fetcher_response_id,
                      //             // dateFrom:record.file_processed==true?record.min_txn_date:null,
                      //             // dateTo:record.file_processed==true?record.max_txn_date:null,
                      //             parse_batch_id:record.file_processed==true?record.id:null,

                      //           })
                      //         }}>
                      //           <span className='error-text'>{formatMoney(error_count, 0)} 
                      //           {record.file_processed==true?" Queued":" Blocks"}</span>
                      //         </Link>}</div>
                      //   }

                      // }
                    ]
                  },
                  {
                    title: "Packets",
                    children: [
                      {
                        title: "Queued",
                        width: 100,
                        key: 'queued_packets',
                        dataIndex: 'queued_packets',
                        className: 'center-align',
                        render: (value, record) => <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center'
                        }}>{record.show_dash == true ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
                          pathname: `/activity/data-type/${record.data_type_id}/packets`,
                          search: queryString.stringify({
                            transferred: 'false',
                            fetcher_response_id: record.fetcher_response_id
                          })
                        }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
                          }</div>
                      },
                      {
                        title: "Transferred",
                        width: 100,
                        key: 'transferred_packets',
                        dataIndex: 'transferred_packets',
                        className: 'center-align',
                        render: (value, record) => <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center'
                        }}>{record.show_dash == true ? <span className='right-align'>-</span> : value > 0 ? <Link to={{
                          pathname: `/activity/data-type/${record.data_type_id}/packets`,
                          search: queryString.stringify({
                            transferred: 'true',
                            fetcher_response_id: record.fetcher_response_id
                          })
                        }}> <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
                          }</div>

                      },
                      {
                        title: "Total",
                        width: 100,
                        key: 'total_packets',
                        dataIndex: 'total_packets',
                        className: 'center-align',
                        render: (value, record) => <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center'
                        }}>{record.show_dash == true ? <span className='right-align'>-</span> :
                          value > 0 ? <Link to={{
                            pathname: `/activity/data-type/${record.data_type_id}/packets`,
                            search: queryString.stringify({
                              fetcher_response_id: record.fetcher_response_id
                            })
                          }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> : <span className='right-align'>{formatMoney(value, 0)}</span>
                          }
                          <GetAppOutlined
                            style={{
                              position: "absolute",
                              right: 10,
                            }}
                            onClick={() => {
                              this.download_transaction.forId(record.id).config({
                                params: {
                                  data_type_id: record.data_type_id
                                }
                              }).execute()
                            }}
                            titleAccess="Download Transaction" className='basic-icon hand-cursor'
                          />
                          </div>
                      }
                    ]
                  },
                ]}
              />
            </div>
          </ErrorWrapper>
        </div>

      </ErrorWrapper>
    );
  }

  componentDidMount() {
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.detail_response.execute()
    })
  }
  componentWillReceiveProps(nextProps) {
    var oldlog_id = this.props.match.params.log_id;
    var newlog_id = nextProps.match.params.log_id;


    var oldresponse_id = this.props.match.params.response_id;
    var newresponse_id = nextProps.match.params.response_id;


    if (oldlog_id !== newlog_id || (
      oldresponse_id !== newresponse_id
    ) || (
        this.props.location && (this.props.location.search !== nextProps.location.search)
      )) {
      this.log_id = newlog_id;
      this.response_id = newresponse_id;

      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed
        },
      }, () => {
        if (oldlog_id !== newlog_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_response.forId(this.log_id).execute()
          })
        } else {
          this.list_data_responses.forId(this.response_id).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default withDomains(FetcherResponseDetail, "fetcher", "activity");
